<template>
  <div class="app-flag" aria-hidden="true">
    <HeaderFlag />
    <div class="app-flag-title">
      <span class="app-flag-title-mark">las islas</span>
      <span class="app-flag-title-sub">admin</span>
    </div>
  </div>

  <header v-if="props.showShell" class="topbar" :style="{ width: props.shellWidth }">
    <div class="topbar-inner">
      <nav class="nav">
        <RouterLink to="/">Dashboard</RouterLink>
        <RouterLink to="/events">Events</RouterLink>
      </nav>

      <div class="user-box">
        <div class="user-identity">
          <span class="user-name">{{ props.user?.name || props.user?.username }}</span>
          <span class="user-role">{{ props.user?.role }}</span>
        </div>
        <button class="btn btn-ghost btn-sm" @click="emit('logout')">Log out</button>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router';
import HeaderFlag from '@/components/HeaderFlag.vue';
import type { AdminUser } from '@/stores/auth';

const props = withDefaults(
  defineProps<{
    showShell?: boolean;
    user?: AdminUser | null;
    shellWidth?: string;
  }>(),
  {
    showShell: false,
    user: null,
    shellWidth: 'min(1120px, calc(100% - 2rem))',
  },
);

const emit = defineEmits<{
  (e: 'logout'): void;
}>();
</script>

<style scoped lang="scss">
.app-flag {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 30;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  pointer-events: none;
  user-select: none;
}

.app-flag-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;
  gap: 2px;
}

.app-flag-title-mark {
  font-family: var(--font-brand);
  font-size: 1.15rem;
  letter-spacing: 0.06em;
  color: var(--text-primary);
  opacity: 0.95;
}

.app-flag-title-sub {
  font-size: 0.6rem;
  text-transform: uppercase;
  letter-spacing: 0.25em;
  color: var(--color-secondary);
  font-weight: 800;
}

.topbar {
  background: rgb(from var(--color-light) r g b / 0.4);
  border: 1px solid var(--border);
  border-radius: 999px;
  backdrop-filter: blur(12px);
  position: fixed;
  top: 1.18rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
}

.topbar-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.5rem 0.65rem;
}

.nav {
  display: flex;
  gap: 0.35rem;

  :deep(a) {
    padding: 0.5rem 0.95rem;
    border-radius: 999px;
    border: 1px solid transparent;
    color: var(--text-secondary);
    font-weight: 600;
    font-size: 0.9rem;
    text-decoration: none;

    &.router-link-active {
      color: var(--color-primary);
      background: rgb(from var(--color-light) r g b / 0.65);
      border-color: var(--border);
    }

    &:hover {
      color: var(--color-primary);
      background: rgb(from var(--color-light) r g b / 0.5);
    }
  }
}

.user-box {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-identity {
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 1.2;
  text-transform: uppercase;
  font-size: 0.9rem;
  gap: 0.25rem;
}

.user-name {
  font-weight: 700;

}

.user-role {
  letter-spacing: 0.1em;
  color: var(--text-muted);
}
</style>
